import { SectionStay } from "../../useFetchSectionStays";
import SectionStayItem from "./SectionStayItem";
import styles from "./styles.scss";
import { useDeleteSectionStay } from "./useDeleteSectionStay";
import { useUpdateSectionStay } from "./useUpdateSectionStay";

interface Props {
  sectionId: string;
  sectionStays: SectionStay[];
}

const SectionStayList = (props: Props) => {
  if (props.sectionStays.length > 0) {
    return (
      <div className={styles.table_wrapper}>
        <table className={styles.table}>
          <thead>
            <TableHeader />
          </thead>
          <tbody>
            <TableBody {...props} />
          </tbody>
        </table>
      </div>
    );
  } else {
    return null;
  }
};

const TableHeader = () => {
  return (
    <tr className={styles.header}>
      <th>氏名</th>
      <th>職業（学年）</th>
      <th>校舎</th>
      <th>入室時間</th>
      <th>退室時間</th>
      <th>滞在時間</th>
      <th></th>
    </tr>
  );
};

interface TableBodyProps extends Props {}

const TableBody = ({ sectionId, sectionStays }: TableBodyProps) => {
  // 表全体で同時に一回のリクエストしか送らないように、ここでmutationを作成
  const updateSectionStayMutation = useUpdateSectionStay({ sectionId });
  const deleteSectionStayMutation = useDeleteSectionStay({ sectionId });

  return sectionStays.map((stay) => {
    return (
      <SectionStayItem
        key={`SectionStay-${stay.id}`}
        stay={stay}
        deleteSectionStayMutation={deleteSectionStayMutation}
        updateSectionStayMutation={updateSectionStayMutation}
      />
    );
  });
};

export default SectionStayList;
